import React, { useState } from "react";
import { users as usersApi } from "../api/endpoints";
import type { User } from "../types";

interface Props {
  user: User;
}

export default function ProfilePage({ user }: Props) {
  const [form, setForm] = useState({
    first_name: user.first_name,
    last_name: user.last_name,
    personal_email: user.personal_email,
    business_phone: user.business_phone,
    personal_phone: user.personal_phone,
    address: user.address,
    city: user.city,
    state: user.state,
    zip_code: user.zip_code,
  });
  const [passwords, setPasswords] = useState({ old_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState("");
  const [pwMsg, setPwMsg] = useState("");

  const handleProfileSave = async (e: React.FormEvent) => {
    e.preventDefault();
    await usersApi.update(user.id, form);
    setMsg("Profile updated");
    setTimeout(() => setMsg(""), 3000);
  };

  const handlePasswordChange = async (e: React.FormEvent) => {
    e.preventDefault();
    if (passwords.new_password !== passwords.confirm) {
      setPwMsg("Passwords don't match");
      return;
    }
    try {
      await usersApi.changePassword(user.id, passwords.old_password, passwords.new_password);
      setPwMsg("Password changed");
      setPasswords({ old_password: "", new_password: "", confirm: "" });
    } catch (err: any) {
      setPwMsg(err.message);
    }
    setTimeout(() => setPwMsg(""), 3000);
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">My Profile</h1>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="font-bold mb-4">Profile Information</h2>
        {msg && <div className="bg-green-50 text-green-700 p-2 rounded mb-3 text-sm">{msg}</div>}
        <form onSubmit={handleProfileSave}>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm text-gray-500 mb-1">First Name</label>
              <input value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Last Name</label>
              <input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Business Email</label>
              <input value={user.email} disabled className="w-full border rounded px-3 py-2 bg-gray-50" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Personal Email</label>
              <input value={form.personal_email} onChange={(e) => setForm({ ...form, personal_email: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Business Phone</label>
              <input value={form.business_phone} onChange={(e) => setForm({ ...form, business_phone: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Personal Phone</label>
              <input value={form.personal_phone} onChange={(e) => setForm({ ...form, personal_phone: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <div className="col-span-2">
              <label className="block text-sm text-gray-500 mb-1">Address</label>
              <input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="w-full border rounded px-3 py-2" />
            </div>
            <input placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="border rounded px-3 py-2" />
            <div className="grid grid-cols-2 gap-2">
              <input placeholder="State" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} className="border rounded px-3 py-2" />
              <input placeholder="Zip" value={form.zip_code} onChange={(e) => setForm({ ...form, zip_code: e.target.value })} className="border rounded px-3 py-2" />
            </div>
          </div>
          <button type="submit" className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Save Profile</button>
        </form>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="font-bold mb-4">Change Password</h2>
        {pwMsg && <div className="bg-yellow-50 text-yellow-700 p-2 rounded mb-3 text-sm">{pwMsg}</div>}
        <form onSubmit={handlePasswordChange}>
          <div className="space-y-3">
            <input type="password" placeholder="Current Password" value={passwords.old_password} onChange={(e) => setPasswords({ ...passwords, old_password: e.target.value })} className="w-full border rounded px-3 py-2" required />
            <input type="password" placeholder="New Password" value={passwords.new_password} onChange={(e) => setPasswords({ ...passwords, new_password: e.target.value })} className="w-full border rounded px-3 py-2" required />
            <input type="password" placeholder="Confirm New Password" value={passwords.confirm} onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })} className="w-full border rounded px-3 py-2" required />
          </div>
          <button type="submit" className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Change Password</button>
        </form>
      </div>
    </div>
  );
}
